var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.template,{tag:"component"},[_c('spark-page-bootstrap',{attrs:{"columns":1}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }